/**
 * Controle de quantidade e remoção de itens para o carrinho lateral - Le Fruit
 */
// Flag para controlar se estamos atualizando o carrinho
let isUpdatingCart = false;

document.addEventListener('DOMContentLoaded', function() {
  initCartControls();
  
  // Garantir que os controles sejam adicionados novamente quando o carrinho for atualizado
  // Usamos o once: true para evitar múltiplos listeners
  document.addEventListener('cart:refreshed', function() {
    // Só inicializar controles se não estivermos no meio de uma atualização
    if (!isUpdatingCart) {
      initCartControls();
    }
  });
});

function initCartControls() {
  // Elementos do carrinho
  const cartDrawer = document.getElementById('CartDrawerCustom');
  if (!cartDrawer) return;
  
  // Inicializar botões de remover
  const removeButtons = cartDrawer.querySelectorAll('.cart-item-remove');
  removeButtons.forEach(button => {
    button.addEventListener('click', handleRemoveItem);
  });
  
  // Inicializar controles de quantidade
  const quantityControls = cartDrawer.querySelectorAll('.quantity-button');
  quantityControls.forEach(button => {
    button.addEventListener('click', handleQuantityChange);
  });
  
  // Inicializar inputs de quantidade
  const quantityInputs = cartDrawer.querySelectorAll('.quantity-input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', handleQuantityInputChange);
    input.addEventListener('keypress', function(e) {
      // Permitir apenas números e tecla Enter
      if (e.key !== 'Enter' && (e.charCode < 48 || e.charCode > 57)) {
        e.preventDefault();
      }
      
      // Atualizar quantidade quando pressionar Enter
      if (e.key === 'Enter') {
        e.preventDefault();
        this.blur();
      }
    });
  });
}

/**
 * Função para remover um item do carrinho
 */
function handleRemoveItem(e) {
  e.preventDefault();
  const itemKey = this.getAttribute('data-cart-remove');
  if (!itemKey) return;
  
  // Se já estamos atualizando o carrinho, não fazer nada
  if (isUpdatingCart) return;
  
  // Indicar que estamos atualizando
  isUpdatingCart = true;
  
  // Exibir indicador de carregamento
  const cartItem = this.closest('.cart-item');
  if (cartItem) {
    cartItem.style.opacity = '0.5';
  }
  
  // Enviar solicitação para remover o item
  const formData = {
    'id': itemKey,
    'quantity': 0
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(cart => {
    // Atualizar o carrinho
    refreshCartDrawer();
    updateCartCountBubble(cart.item_count);
    
    // Indicar que terminamos a atualização após um pequeno delay
    setTimeout(() => {
      isUpdatingCart = false;
    }, 300);
  })
  .catch(error => {
    console.error('Erro ao remover item:', error);
    if (cartItem) {
      cartItem.style.opacity = '1';
    }
    isUpdatingCart = false;
  });
}

/**
 * Função para alterar a quantidade de um item
 */
function handleQuantityChange(e) {
  e.preventDefault();
  const itemKey = this.getAttribute('data-cart-item-key');
  const action = this.getAttribute('data-action');
  if (!itemKey || !action) return;
  
  // Encontrar o input de quantidade relacionado
  const quantityInput = this.closest('.quantity-selector').querySelector('.quantity-input');
  if (!quantityInput) return;
  
  let currentQty = parseInt(quantityInput.value, 10);
  if (isNaN(currentQty)) currentQty = 1;
  
  // Calcular nova quantidade
  let newQty = currentQty;
  if (action === 'increase') {
    newQty = currentQty + 1;
  } else if (action === 'decrease') {
    newQty = Math.max(1, currentQty - 1);
  }
  
  // Se a quantidade não mudou, não fazer nada
  if (newQty === currentQty) return;
  
  // Atualizar o input visual
  quantityInput.value = newQty;
  
  // Exibir indicador de carregamento
  const cartItem = this.closest('.cart-item');
  if (cartItem) {
    cartItem.style.opacity = '0.5';
  }
  
  // Enviar solicitação para atualizar a quantidade
  updateCartItemQuantity(itemKey, newQty, cartItem);
}

/**
 * Função para lidar com alterações manuais no input de quantidade
 */
function handleQuantityInputChange(e) {
  const itemKey = this.getAttribute('data-cart-item-key');
  if (!itemKey) return;
  
  let newQty = parseInt(this.value, 10);
  if (isNaN(newQty) || newQty < 1) {
    newQty = 1;
    this.value = 1;
  }
  
  // Exibir indicador de carregamento
  const cartItem = this.closest('.cart-item');
  if (cartItem) {
    cartItem.style.opacity = '0.5';
  }
  
  // Enviar solicitação para atualizar a quantidade
  updateCartItemQuantity(itemKey, newQty, cartItem);
}

/**
 * Função para atualizar a quantidade de um item no carrinho
 */
function updateCartItemQuantity(itemKey, quantity, cartItem) {
  // Se já estamos atualizando o carrinho, não fazer nada
  if (isUpdatingCart) return;
  
  // Indicar que estamos atualizando
  isUpdatingCart = true;
  
  const formData = {
    'id': itemKey,
    'quantity': quantity
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(cart => {
    // Atualizar o carrinho
    refreshCartDrawer();
    updateCartCountBubble(cart.item_count);
    
    // Indicar que terminamos a atualização após um pequeno delay
    setTimeout(() => {
      isUpdatingCart = false;
    }, 300);
  })
  .catch(error => {
    console.error('Erro ao atualizar quantidade:', error);
    if (cartItem) {
      cartItem.style.opacity = '1';
    }
    isUpdatingCart = false;
  });
}

/**
 * Função para atualizar o carrinho lateral
 */
function refreshCartDrawer() {
  // Se já estamos no processo de atualização, não iniciar outra
  if (isUpdatingCart) return;
  
  // Fazer fetch dos dados atualizados do carrinho
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Atualizar total geral do carrinho
      const cartSubtotal = document.querySelector('.cart-subtotal span:last-child');
      if (cartSubtotal) {
        cartSubtotal.textContent = formatMoney(cart.total_price);
      }
      
      // Atualizar o contador de itens no ícone do carrinho
      updateCartCountBubble(cart.item_count);
      
      // Atualizar preços individuais dos itens sem disparar novos eventos de change
      const updatingQuantities = [];
      
      cart.items.forEach(item => {
        const cartItemElement = document.querySelector(`.cart-item[data-cart-item-key="${item.key}"]`);
        if (cartItemElement) {
          const priceElement = cartItemElement.querySelector('.cart-item-price');
          if (priceElement) {
            priceElement.textContent = formatMoney(item.final_line_price);
          }
          
          // Atualizar a quantidade no campo (sem disparar eventos)
          const quantityInput = cartItemElement.querySelector('.quantity-input');
          if (quantityInput && quantityInput.value != item.quantity) {
            // Armazenar o evento change original
            const originalOnChange = quantityInput.onchange;
            // Desativar temporariamente
            quantityInput.onchange = null;
            // Atualizar o valor
            quantityInput.value = item.quantity;
            // Restaurar o evento original
            quantityInput.onchange = originalOnChange;
          }
        }
      });
      
      // Se temos a função global, usar ela também (mas apenas se não estamos já atualizando)
      if (typeof window.refreshCartDrawer === 'function' && !isUpdatingCart) {
        window.refreshCartDrawer();
      }
      
      // Disparar evento para atualizar o carrinho (apenas uma vez)
      document.dispatchEvent(new CustomEvent('cart:refreshed', { detail: cart }));
    })
    .catch(error => {
      console.error('Erro ao atualizar o carrinho:', error);
    });
}

/**
 * Formatar valor monetário no formato R$ XX,XX
 */
function formatMoney(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  cents = parseFloat(cents) / 100;
  
  return 'R$ ' + cents.toFixed(2).replace('.', ',');
}

/**
 * Função para atualizar o contador de itens no ícone do carrinho
 */
function updateCartCountBubble(count) {
  const cartCountBubble = document.querySelector('.cart-count-bubble');
  if (cartCountBubble) {
    const cartCountSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
    if (cartCountSpan) {
      if (count > 0) {
        cartCountSpan.textContent = count;
        cartCountBubble.style.display = 'flex';
      } else {
        cartCountBubble.style.display = 'none';
      }
    }
  }
}
